const grade_7= {
    label: "Grade 7",
    subjects: {
      "applied_design_7": {
    "label": "Applied Design (Grade 7)",
    "topics": [
      { "value": "Understanding_Context", "label": "Understanding Context" },
      { "value": "defining", "label": "Defining" },
      { "value": "ideating", "label": "Ideating" },
      { "value": "prototyping", "label": "Prototyping" },
      { "value": "testing", "label": "Testing" },
      { "value": "making", "label": "Making" },
      { "value": "sharing", "label": "Sharing" },
      { "value": "applied_skills", "label": "Applied Skills" },
      { "value": "applied_technologies", "label": "Applied Technologies" }
    ],
    "competencies": {
      "core": [
      { "value": "Understanding_Context", "label": "Understanding Context" },
      { "value": "defining", "label": "Defining" },
      { "value": "ideating", "label": "Ideating" },
      { "value": "prototyping", "label": "Prototyping" },
      { "value": "testing", "label": "Testing" },
      { "value": "making", "label": "Making" },
      { "value": "sharing", "label": "Sharing" },
      { "value": "applied_skills", "label": "Applied Skills" },
      { "value": "applied_technologies", "label": "Applied Technologies" }
      ],
     "sub": {
        "applied_design": [
          /* -------------------- Defining -------------------- */
          {
            "value": "empathize_with_users",
            "label": "Empathize with potential users to find issues and uncover needs and potential design opportunities"
          },
          {
            "value": "choose_design_opportunity",
            "label": "Choose a design opportunity"
          },
          {
            "value": "identify_key_features_users",
            "label": "Identify key features or potential users and their requirements"
          },
          {
            "value": "identify_criteria_constraints",
            "label": "Identify criteria for success and any constraints"
          },

          /* -------------------- Ideating -------------------- */
          {
            "value": "generate_potential_ideas",
            "label": "Generate potential ideas and add to others’ ideas"
          },
          {
            "value": "screen_ideas",
            "label": "Screen ideas against criteria and constraints"
          },
          {
            "value": "evaluate_impacts_ethics",
            "label": "Evaluate personal, social, and environmental impacts and ethical considerations"
          },
          {
            "value": "choose_idea_to_pursue",
            "label": "Choose an idea to pursue"
          },
          {
            "value": "identify_use_information_sources",
            "label": "Identify and use sources of information"
          },

          /* -------------------- Prototyping -------------------- */
          {
            "value": "develop_plan_stages_resources",
            "label": "Develop a plan that identifies key stages and resources"
          },
          {
            "value": "explore_test_materials",
            "label": "Explore and test a variety of materials for effective use"
          },
          {
            "value": "construct_first_version",
            "label": "Construct a first version of the product or a prototype, making changes to tools, materials, and procedures as needed"
          },
          {
            "value": "record_iterations",
            "label": "Record iterations of prototyping"
          },

          /* -------------------- Testing -------------------- */
          {
            "value": "test_first_version",
            "label": "Test the first version of the product or the prototype"
          },
          {
            "value": "gather_peer_user_expert_feedback",
            "label": "Gather peer, user, and/or expert feedback and inspiration"
          },
          {
            "value": "make_changes_troubleshoot_test",
            "label": "Make changes, troubleshoot, and test again"
          },

          /* -------------------- Making -------------------- */
          {
            "value": "identify_use_tools_materials",
            "label": "Identify and use appropriate tools, technologies, and materials for production"
          },
          {
            "value": "make_production_plan",
            "label": "Make a plan for production that includes key stages, and carry it out, making changes as needed"
          },
          {
            "value": "minimize_waste",
            "label": "Use materials in ways that minimize waste"
          },

          /* -------------------- Sharing -------------------- */
          {
            "value": "decide_sharing",
            "label": "Decide on how and with whom to share their product"
          },
          {
            "value": "demonstrate_product_process",
            "label": "Demonstrate their product and describe their process, using appropriate terminology and providing reasons for their selected solution and modifications"
          },
          {
            "value": "evaluate_against_criteria",
            "label": "Evaluate their product against their criteria and explain how it contributes to the individual, family, community, and/or environment"
          },
          {
            "value": "reflect_on_design_thinking",
            "label": "Reflect on their design thinking and processes, and evaluate their ability to work effectively both as individuals and collaboratively in a group, including their ability to share and maintain an efficient co-operative workspace"
          },
          {
            "value": "identify_new_design_issues",
            "label": "Identify new design issues"
          }
        ],

        /* -------------------- Applied Skills -------------------- */
        "applied_skills": [
          {
            "value": "awareness_safety_procedures",
            "label": "Demonstrate an awareness of precautionary and emergency safety procedures in both physical and digital environments"
          },
          {
            "value": "identify_evaluate_skills",
            "label": "Identify and evaluate the skills and skill levels needed, individually or as a group, in relation to a specific task, and develop them as needed"
          }
        ],

        /* -------------------- Applied Technologies -------------------- */
        "applied_technologies": [
          {
            "value": "select_learn_technologies",
            "label": "Select, and as needed learn about, appropriate tools and technologies to extend their capability to complete a task"
          },
          {
            "value": "identify_impacts_of_technology",
            "label": "Identify the personal, social, and environmental impacts, including unintended negative consequences, of the choices they make about technology use"
          },
          {
            "value": "identify_land_resource_culture_influence",
            "label": "Identify how the land, natural resources, and culture influence the development and use of tools and technologies"
          }
        ]
      }
    }
  }
,    
  
  "arts_7": {
    "label": "Arts Education (Grade 7)",
   topics: [
        { value: "Expanding and Creating", label: "Expanding and Creating" },
        { value: "reasoning_reflecting", label: "Reasoning and Reflecting" },
        { value: "communicating_documenting", label: "Communicating and Documenting" },
        // { value: "connecting_expanding", label: "Connecting and Expanding" }
      ],
      competencies: {
        core: [
          { value: "Exploring", label: "Expanding and Creating" },
          { value: "Reasoning", label: "Reasoning and Reflecting" },
          { value: "Communicating", label: "Communicating and Documenting" },
          // { value: "Connecting", label: "Connecting and Expanding" }
        ],

      "sub": {
        "exploring_creating": [
          {
            "value": "select_apply_elements_grade7",
            "label": "Intentionally select and apply materials, movements, technologies, environments, tools, and techniques by combining and arranging artistic elements, processes, and principles in art making"
          },
          {
            "value": "create_artistic_works_grade7",
            "label": "Create artistic works collaboratively and as an individual using ideas inspired by imagination, inquiry, experimentation, and purposeful play"
          },
          {
            "value": "explore_identity_place_culture_society_grade7",
            "label": "Explore relationships between identity, place, culture, society, and belonging through the arts"
          }
        ],

        "reasoning_reflecting": [
          {
            "value": "understand_contexts_grade7",
            "label": "Demonstrate an understanding and appreciation of personal, social, cultural, historical, and environmental contexts in relation to the arts"
          },
          {
            "value": "research_describe_evaluate_artists_grade7",
            "label": "Research, describe, interpret, and evaluate how artists use processes, materials, movements, technologies, tools, techniques, and environments in the arts"
          },
          {
            "value": "develop_refine_ideas_skills_grade7",
            "label": "Develop and refine ideas, processes, and technical skills in a variety of art forms to improve the quality of artistic creations"
          },
          {
            "value": "reflect_understand_artist_intentions_grade7",
            "label": "Reflect on works of art and creative processes to understand artists’ intentions"
          },
          {
            "value": "interpret_using_other_learning_grade7",
            "label": "Interpret works of art using knowledge and skills from various areas of learning"
          }
        ],

        "communicating_documenting": [
          {
            "value": "interpret_communicate_symbols_grade7",
            "label": "Interpret and communicate ideas using symbols and elements to express meaning through the arts"
          },
          {
            "value": "take_creative_risks_grade7",
            "label": "Take creative risks to express feelings, ideas, and experiences"
          },
          {
            "value": "express_feelings_ideas_experiences_grade7",
            "label": "Express feelings, ideas, and experiences through the arts"
          },
          {
            "value": "describe_interpret_respond_art_grade7",
            "label": "Describe, interpret, and respond to works of art"
          }
        ],

        "connecting_expanding": [
          {
            "value": "examine_arts_wider_world_grade7",
            "label": "Examine relationships between the arts and the wider world"
          },
          {
            "value": "adapt_skills_new_contexts_grade7",
            "label": "Adapt learned skills, understandings, and processes for use in new contexts and for different purposes and audiences"
          },
          {
            "value": "experience_document_choreograph_perform_share_grade7",
            "label": "Experience, document, choreograph, perform, and share creative works in a variety of ways"
          },
          {
            "value": "demonstrate_sophisticated_application_grade7",
            "label": "Demonstrate increasingly sophisticated application and/or engagement of curricular content"
          }
        ]
      }
    }
  },
   career_education_7: {
        label: 'Career Education (Grade 7)',
        topics: [],
        competencies: {
          core: [
            { value: 'examine', label: 'Examine' },
            { value: 'interact', label: 'Interact' },
            { value: 'experience', label: 'Experience' },
            { value: 'initiate', label: 'Initiate' },
            { value: 'share', label: 'Share' }
          ],
          sub: {
            examine: [
              { value: 'recognize_their_personal_preferences_skills_strengths_and_abilities', label: 'Recognize their personal preferences, skills, strengths, and abilities and connect them to possible career choices' },
              { value: 'question_self_and_others_about_the_reciprocal_relationship', label: 'Question self and others about the reciprocal relationship between self and community' }
            ],
            interact: [
              { value: 'appreciate_the_importance_of_respect_inclusivity_and_other_positive_behaviours', label: 'Appreciate the importance of respect, inclusivity, and other positive behaviours in diverse, collaborative learning, and work environments' },
              { value: 'recognize_the_influence_of_peers_family_and_communities', label: 'Recognize the influence of peers, family, and communities on career choices and attitudes toward work' }
            ],
            experience: [
              { value: 'appreciate_the_value_of_new_experiences', label: 'Appreciate the value of new experiences, innovative thinking, and risk taking in broadening their career options' },
              { value: 'explore_volunteer_opportunities', label: 'Explore volunteer opportunities and other new experiences outside school and recognize their value in career development' },
              { value: 'apply_project_management_skills', label: 'Apply project management skills to support career development' }
            ],
            initiate: [
              { value: 'set_realistic_short_and_longer_term_learning_goals', label: 'Set realistic short- and longer-term learning goals, define a path, and monitor progress' },
              { value: 'demonstrate_leadership_skills', label: 'Demonstrate leadership skills through collaborative activities in the school and community' },
              { value: 'demonstrate_safety_skills', label: 'Demonstrate safety skills in an experiential learning environment' },
              { value: 'use_entrepreneurial_and_innovative_thinking', label: 'Use entrepreneurial and innovative thinking to solve problems' }
            ],
            share: [
              { value: 'examine_the_importance_of_service_learning', label: 'Examine the importance of service learning and the responsibility of individuals to contribute to the community and the world' },
              { value: 'question_self_and_others_about_how_their_personal_public_identity', label: 'Question self and others about how their personal public identity can have both positive and negative consequences' }
            ]
          }
        }
      },    
 "english_7": {
    "label": "English Language Arts (Grade 7)",
    "topics": [
      { "value": "comprehend_connect", "label": "Comprehend and Connect (Reading, Listening, Viewing)" },
      { "value": "create_communicate", "label": "Create and Communicate (Writing, Speaking, Representing)" }
    ],
    "competencies": {
      "core": [
        { "value": "comprehend_connect", "label": "Comprehend and Connect (reading, listening, viewing)" },
        { "value": "create_communicate", "label": "Create and Communicate (writing, speaking, representing)" }
      ],
      "sub": {
        "comprehend_connect": [
          {
            "value": "access_info_evaluate",
            "label": "Access information and ideas for diverse purposes from a variety of sources and evaluate their relevance, accuracy, and reliability (Grade 6–9)"
          },
          {
            "value": "apply_strategies_comprehend",
            "label": "Apply appropriate strategies to comprehend written, oral, and visual texts, guide inquiry, and extend thinking (Grade 6–9)"
          },
          {
            "value": "synthesize_ideas_sources",
            "label": "Synthesize ideas from a variety of sources to build understanding (Grade 5–9)"
          },
          {
            "value": "recognize_text_features_genres",
            "label": "Recognize and appreciate how different features, forms, and genres of texts reflect different purposes, audiences, and messages (Grade 6–9)"
          },
          {
            "value": "think_critically_creatively",
            "label": "Think critically, creatively, and reflectively to explore ideas within, between, and beyond texts (Grade 6–9)"
          },
          {
            "value": "identify_personal_social_cultural_context",
            "label": "Recognize and identify the role of personal, social, and cultural contexts, values, and perspectives in texts (Grade 6–9)"
          },
          {
            "value": "recognize_language_identity",
            "label": "Recognize how language constructs personal, social, and cultural identity (Grade 6–9)"
          },
          {
            "value": "construct_personal_connections",
            "label": "Construct meaningful personal connections between self, text, and world (Grade 6–9)"
          },
          {
            "value": "respond_text_personal_creative_critical",
            "label": "Respond to text in personal, creative, and critical ways (Grade 6–9)"
          },
          {
            "value": "explain_literary_elements_devices",
            "label": "Understand or explain how literary elements, techniques, and devices enhance and shape meaning (Grade 6–9)"
          },
          {
            "value": "recognize_text_structures",
            "label": "Recognize an increasing range of text structures and how they contribute to meaning (Grade 6–9)"
          },
          {
            "value": "appreciate_fp_story_role",
            "label": "Recognize and appreciate the role of story, narrative, and oral tradition in expressing First Peoples perspectives, values, beliefs, and points of view (Grade 6–9)"
          },
          {
            "value": "fp_protocols_ownership",
            "label": "Develop an awareness of the protocols, ownership, and diversity within and across First Peoples texts (Grade 8–9)"
          },
          {
            "value": "influence_of_place_texts",
            "label": "Recognize the influence of place in First Peoples and other Canadian texts (Grade 6–9)"
          }
        ],

        "create_communicate": [
          {
            "value": "exchange_ideas_viewpoints",
            "label": "Exchange ideas and viewpoints to build shared understanding and extend thinking (Grade 6–9)"
          },
          {
            "value": "writing_design_processes_6_9",
            "label": "Use writing and design processes to plan, develop, and create engaging and meaningful literary and informational texts for a variety of purposes and audiences (Grade 6–9)"
          },
          {
            "value": "assess_refine_texts",
            "label": "Assess and refine texts to improve their clarity, effectiveness, and impact according to purpose, audience, and message (Grade 6–9)"
          },
          {
            "value": "use_canadian_conventions",
            "label": "Use an increasing repertoire of conventions of Canadian spelling, grammar, and punctuation (Grade 6–9)"
          },
          {
            "value": "oral_storytelling_processes",
            "label": "Use and experiment with oral storytelling processes (Grade 6–9)"
          },
          {
            "value": "select_features_forms_genres",
            "label": "Select and use appropriate features, forms, and genres according to audience, purpose, and message (Grade 6–9)"
          },
          {
            "value": "transform_ideas_original_texts",
            "label": "Transform ideas and information to create original texts (Grade 4–9)"
          },
          {
            "value": "express_opinion_support_evidence",
            "label": "Express an opinion and support it with credible evidence (Grade 9 emphasis)"
          }
        ]
      }
    }
  },
      
"math_7": {
      "label": "Mathematics (Grade 7)",
"topics": [
      { "value": "reasoning_analyzing", "label": "Reasoning and Analyzing" },
      { "value": "understanding_solving", "label": "Understanding and Solving" },
      { "value": "communicating_representing", "label": "Communicating and Representing" },
      { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
    ],

    "competencies": {
      "core": [
        { "value": "reasoning_analyzing", "label": "Reasoning and Analyzing" },
        { "value": "understanding_solving", "label": "Understanding and Solving" },
        { "value": "communicating_representing", "label": "Communicating and Representing" },
        { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
      ],

      "sub": {
        "reasoning_analyzing": [
          {
            "value": "use_logic_patterns_solve_puzzles_6_9",
            "label": "Use logic and patterns to solve puzzles and play games"
          },
          {
            "value": "reason_analyze_apply_math_ideas_6_9",
            "label": "Use reasoning and logic to explore, analyze, and apply mathematical ideas"
          },
          {
            "value": "estimate_reasonably_6_9",
            "label": "Estimate reasonably"
          },
          {
            "value": "mental_math_strategies_6_9",
            "label": "Demonstrate and apply mental math strategies"
          },
          {
            "value": "use_tools_technology_patterns_6_9",
            "label": "Use tools or technology to explore and create patterns and relationships, and test conjectures"
          }
        ],

        "understanding_solving": [
          {
            "value": "model_mathematics_context_6_9",
            "label": "Model mathematics in contextualized experiences"
          },
          {
            "value": "apply_multiple_problem_solving_strategies_6_9",
            "label": "Apply multiple strategies to solve problems in both abstract and contextualized situations"
          },
          {
            "value": "demonstrate_math_understanding_6_9",
            "label": "Develop, demonstrate, and apply mathematical understanding through play, inquiry, and problem solving"
          },
          {
            "value": "visualize_explore_math_concepts_6_9",
            "label": "Visualize to explore mathematical concepts"
          },
          {
            "value": "problem_solving_local_culture_6_9",
            "label": "Engage in problem-solving experiences connected to place, story, cultural practices, and perspectives relevant to local First Peoples communities, the local community, and other cultures"
          }
        ],

        "communicating_representing": [
          {
            "value": "use_math_vocabulary_discussions_6_9",
            "label": "Use mathematical vocabulary and language to contribute to mathematical discussions"
          },
          {
            "value": "explain_justify_math_ideas_6_9",
            "label": "Explain and justify mathematical ideas and decisions"
          },
          {
            "value": "communicate_math_thinking_6_9",
            "label": "Communicate mathematical thinking in many ways"
          },
          {
            "value": "represent_math_ideas_6_9",
            "label": "Represent mathematical ideas in concrete, pictorial, and symbolic forms"
          }
        ],

        "connecting_reflecting": [
          {
            "value": "reflect_math_thinking_6_9",
            "label": "Reflect on mathematical thinking"
          },
          {
            "value": "connect_math_concepts_6_9",
            "label": "Connect mathematical concepts to each other and to other areas and personal interests"
          },
          {
            "value": "use_math_arguments_support_choices_6_9",
            "label": "Use mathematical arguments to support personal choices"
          },
          {
            "value": "incorporate_first_peoples_perspectives_6_9",
            "label": "Incorporate First Peoples worldviews and perspectives to make connections to mathematical concepts"
          }
        ]
      }
    }
  }
,

 "phe_7": {
    "label": "Physical and Health Education (Grade 7)",
    "topics": [
      { "value": "physical_literacy", "label": "Physical Literacy" },
      { "value": "healthy_active_living", "label": "Healthy and Active Living" },
      { "value": "social_community_health", "label": "Social and Community Health" },
      { "value": "mental_well_being", "label": "Mental Well-Being" }
    ],

    "competencies": {
      "core": [
        { "value": "physical_literacy", "label": "Physical Literacy" },
        { "value": "healthy_active_living", "label": "Healthy and Active Living" },
        { "value": "social_community_health", "label": "Social and Community Health" },
        { "value": "mental_well_being", "label": "Mental Well-Being" }
      ],

      "sub": {
        "physical_literacy": [
          {
            "value": "refine_apply_movement_skills_7",
            "label": "Refine and apply fundamental movement skills in a variety of physical activities and environments (6–7)"
          },
          {
            "value": "apply_movement_concepts_strategies_7",
            "label": "Apply movement concepts and strategies in different physical activities (3–6)"
          },
          {
            "value": "safety_fair_play_leadership_7",
            "label": "Develop and demonstrate safety, fair play, and leadership in physical activities (K–9)"
          },
          {
            "value": "identify_preferred_activities_7",
            "label": "Identify and describe preferred types of physical activity (4–9)"
          },
          {
            "value": "analyze_personal_habits_7",
            "label": "Analyze strategies for developing and maintaining positive personal habits"
          }
        ],

        "healthy_active_living": [
          {
            "value": "participate_daily_activity_7",
            "label": "Participate daily in physical activity at moderate to vigorous intensity levels (K–9)"
          },
          {
            "value": "healthy_eating_strategies_7",
            "label": "Describe strategies for making healthy eating choices (6–8)"
          },
          {
            "value": "personal_healthy_living_goals_7",
            "label": "Describe strategies for pursuing personal healthy-living goals (6–7)"
          },
          {
            "value": "factors_influencing_healthy_choices_7",
            "label": "Identify factors influencing healthy choices and eating habits (6–7)"
          },
          {
            "value": "strategies_transitions_relationships_7",
            "label": "Identify strategies for managing transitions and developing healthy relationships"
          }
        ],

        "social_community_health": [
          {
            "value": "discrimination_stereotyping_bullying_7",
            "label": "Describe and assess strategies for responding to discrimination, stereotyping, and bullying (4–7)"
          },
          {
            "value": "outdoor_activities_community_connection_7",
            "label": "Explain how participation in outdoor activities supports connections with community and environment (6–7)"
          },
          {
            "value": "leadership_collaboration_7",
            "label": "Demonstrate leadership and collaborative skills in group activities"
          }
        ],

        "mental_well_being": [
          {
            "value": "strategies_promote_mental_wellbeing_7",
            "label": "Describe and assess strategies for promoting mental well-being (6–8)"
          },
          {
            "value": "manage_mental_wellbeing_substance_7",
            "label": "Apply strategies for managing problems related to mental well-being and substance use (6–8)"
          },
          {
            "value": "factors_influencing_self_identity_7",
            "label": "Describe factors that influence self-identity (4–7)"
          },
          {
            "value": "manage_changes_puberty_7",
            "label": "Describe strategies for managing changes during puberty"
          }
        ]
      }
    }
  },

      science_7: {
        label: "Science (Grade 7)",
        topics: [
          { value: "cells_tissues", label: "Cells and Tissues" },
          { value: "energy_transfer", label: "Energy Transfer" },
          { value: "earth_processes", label: "Earth Processes" }
        ],
        competencies: {
          core: [
            { value: "questioning_predicting", label: "Questioning and Predicting" },
            { value: "planning_conducting", label: "Planning and Conducting" },
            { value: "processing_analyzing", label: "Processing and Analyzing Data and Information" },
            { value: "evaluating", label: "Evaluating" },
            { value: "applying_innovating", label: "Applying and Innovating" },
            { value: "communicating", label: "Communicating" }
          ],
          sub: {
            questioning_predicting: [
              { value: "intellectual_curiosity", label: "Demonstrate sustained intellectual curiosity about a scientific topic or problem of personal interest" },
              { value: "observations_form_questions", label: "Make observations aimed at identifying their own questions about the natural world" },
              { value: "alternative_hypotheses", label: "Formulate alternative “If…then…” hypotheses" },
              { value: "predict_findings", label: "Make predictions about findings" }
            ],

            planning_conducting: [
              { value: "collaborative_planning", label: "Collaboratively plan a range of investigation types, including field work and experiments" },
              { value: "measure_control_variables", label: "Measure and control variables (dependent and independent) through fair tests" },
              { value: "record_accurate_data", label: "Observe, measure, and record data (qualitative and quantitative) accurately" },
              { value: "use_SI_units", label: "Use appropriate SI units and perform simple conversions" },
              { value: "follow_safety_ethics", label: "Ensure that safety and ethical guidelines are followed" }
            ],

            processing_analyzing: [
              { value: "first_peoples_perspectives", label: "Apply First Peoples perspectives and local knowledge as sources of information" },
              { value: "represent_patterns", label: "Construct and use tables, graphs, models, and digital technologies to represent patterns" },
              { value: "seek_patterns_connections", label: "Seek patterns and connections in data" },
              { value: "scientific_relationships", label: "Use scientific understandings to identify relationships and draw conclusions" }
            ],

            evaluating: [
              { value: "reflect_methods", label: "Reflect on investigation methods and quality of data" },
              { value: "identify_sources_error", label: "Identify possible sources of error and suggest improvements" },
              { value: "assumptions_bias", label: "Demonstrate awareness of assumptions and bias" },
              { value: "evaluate_secondary_claims", label: "Exercise healthy, informed skepticism and evaluate claims in secondary sources" },
              { value: "social_ethical_environmental", label: "Consider social, ethical, and environmental implications" }
            ],

            applying_innovating: [
              { value: "care_self_community_world", label: "Contribute to care for self, others, community, and world through personal or collaborative approaches" },
              { value: "cooperative_design", label: "Co-operatively design projects" },
              { value: "apply_learning", label: "Transfer and apply learning to new situations" },
              { value: "generate_new_ideas", label: "Generate and introduce new or refined ideas when problem solving" }
            ],

            communicating: [
              { value: "communicate_scientific_language", label: "Communicate ideas, findings, and solutions using scientific language and digital tools" },
              { value: "express_reflect_place", label: "Express and reflect on a variety of experiences and perspectives of place" }
            ]
          }
        }
      },
      core_french_7: {
        label: 'Core French',
        topics: [],
        competencies: {
          core: [
            { value: 'thinking_and_communicating', label: 'Thinking and Communicating' },
            { value: 'personal_and_social_awareness', label: 'Personal and Social Awareness' }
          ],
          sub: {
            thinking_and_communicating: [
              { value: 'recognize_letter_patterns_pronunciation', label: 'Recognize the relationships between French letter patterns and pronunciation' },
              { value: 'comprehend_key_information_supporting_details', label: 'Comprehend key information and supporting details in slow, clear speech and other simple texts' },
              { value: 'comprehend_simple_stories', label: 'Comprehend simple stories' },
              { value: "use_various_strategies", label: "Use various strategies to support communication" },
              { value: "seek_clarification", label: "Seek clarification of meaning" },
              { value: 'use_intonation_tone_effectively', label: 'Use intonation and tone effectively to communicate meaning' },
              { value: 'follow_instructions_to_complete_task', label: 'Follow instructions to complete a task' },
              { value: 'exchange_ideas_information', label: 'Exchange ideas and information using complete sentences, both orally and in writing' },
              { value: 'express_and_comprehend_others', label: 'Express themselves and comprehend others through various modes of presentation' }
            ],
            personal_and_social_awareness: [
              { value: 'explore_share_info_francophone_communities', label: 'Explore and share information about Francophone communities across Canada and around the world' },
              { value: 'explore_share_info_connections_first_peoples', label: 'Explore and share information about connections between First Peoples communities and the French language' },
              { value: 'describe_cultural_aspects_francophone_communities', label: 'Describe cultural aspects of Francophone communities' }
            ]
          }
        }
      },
      
     
      
  "social_studies_7": {
    "label": "Social Studies (Grade 7)",
   "topics": [
      { "value": "inquiry", "label": "Inquiry" },
      { "value": "significance", "label": "Significance" },
      { "value": "evidence", "label": "Evidence" },
      { "value": "continuity_change", "label": "Continuity and Change" },
      { "value": "cause_consequence", "label": "Cause and Consequence" },
      { "value": "perspective", "label": "Perspective" },
      { "value": "ethical_judgement", "label": "Ethical Judgement" }
    ],

    "competencies": {
      "core": [
        { "value": "inquiry", "label": "Inquiry" },
        { "value": "significance", "label": "Significance" },
        { "value": "evidence", "label": "Evidence" },
        { "value": "continuity_change", "label": "Continuity and Change" },
        { "value": "cause_consequence", "label": "Cause and Consequence" },
        { "value": "perspective", "label": "Perspective" },
        { "value": "ethical_judgement", "label": "Ethical Judgement" }
      ],
      "sub": {
        "inquiry": [
          {
            "value": "inquiry_process_ss7_8",
            "label": "Use Social Studies inquiry processes and skills to ask questions; gather, interpret, and analyze ideas; and communicate findings and decisions"
          }
        ],

        "significance": [
          {
            "value": "assess_significance_ss7_8",
            "label": "Assess the significance of people, places, events, or developments at particular times and places"
          },
          {
            "value": "identify_creators_significance_ss7_8",
            "label": "Identify what the creators of accounts, narratives, maps, or texts have determined is significant"
          }
        ],

        "evidence": [
          {
            "value": "assess_credibility_sources_ss7_8",
            "label": "Assess the credibility of multiple sources and the adequacy of evidence used to justify conclusions"
          }
        ],

        "continuity_change": [
          {
            "value": "characterize_time_periods_ss7_8",
            "label": "Characterize different time periods in history, including periods of progress and decline, and identify key turning points that marked periods of change"
          }
        ],

        "cause_consequence": [
          {
            "value": "determine_causes_consequences_ss7_8",
            "label": "Determine which causes most influenced particular decisions, actions, or events, and assess their short- and long-term consequences"
          }
        ],

        "perspective": [
          {
            "value": "explain_compare_perspectives_ss7_8",
            "label": "Explain different perspectives on past or present people, places, issues, or events, and compare the values, worldviews, and beliefs of human cultures and societies in different times and places"
          }
        ],

        "ethical_judgement": [
          {
            "value": "make_ethical_judgments_past_ss7_8",
            "label": "Make ethical judgments about past events, decisions, or actions, and assess the limitations of drawing direct lessons from the past"
          }
        ]
      }
    }
  }
,
 
   

    }
  }
    export default grade_7;